/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationCountriesQueryResponse,
  GetApiV1LocationCountries401,
  GetApiV1LocationCountries500,
} from "../../types/locationCountryController/GetApiV1LocationCountries.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationCountries } from "../../clients/locationCountryController/getApiV1LocationCountries.ts";

export const getApiV1LocationCountriesQueryKey = () =>
  [{ url: "/api/v1/location/countries" }] as const;

export type GetApiV1LocationCountriesQueryKey = ReturnType<
  typeof getApiV1LocationCountriesQueryKey
>;

export function getApiV1LocationCountriesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationCountriesQueryKey();
  return queryOptions<
    GetApiV1LocationCountriesQueryResponse,
    ResponseErrorConfig<
      GetApiV1LocationCountries401 | GetApiV1LocationCountries500
    >,
    GetApiV1LocationCountriesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationCountries({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os países cadastrados, com o nome resolvido pelo idioma corrente, ordenados alfabeticamente. **(Requer Authorization para autenticação)**
 * @summary Listar países (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries}
 */
export function useGetApiV1LocationCountries<
  TData = GetApiV1LocationCountriesQueryResponse,
  TQueryData = GetApiV1LocationCountriesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationCountriesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationCountriesQueryResponse,
        ResponseErrorConfig<
          GetApiV1LocationCountries401 | GetApiV1LocationCountries500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1LocationCountriesQueryKey();

  const query = useQuery(
    {
      ...getApiV1LocationCountriesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1LocationCountries401 | GetApiV1LocationCountries500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
